import styled from 'styled-components'
import { primary, bgPrimaryLight, primaryGradient, widthFull, widthResize, heightHeader, widthWithPadding, widthResizeWithPadding } from '../Resources/Theme'

const Nav = styled.div`
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: 100%;
  background: #101812;
  overflow: hidden;
  transition: .3s ease;
  z-index: 60;
  border-right: 1px solid rgba(255,255,255,.05);
  box-shadow: 14px 0 40px rgba(15,23,42,.08);

  &:hover {
    overflow: auto;
    overflow-x: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: #111827;
    position: fixed;
    margin-top: ${heightHeader};
  }

  &::-webkit-scrollbar {
    width: .3rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #A3A3A3;
    border-radius: 6px;
  }

  @media (max-width: 992px) {
    width: ${widthFull};
    margin-left: -${props => props.mobile ? '0' : '280'}px;
    overflow: auto;
    overflow-x: hidden;
  }
`

Nav.Bg = styled.div`
  display: none;
  z-index: 99;

  @media (max-width: 992px) {
    display: ${props => props.mobile ? 'block' : 'none'};
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: ${bgPrimaryLight};
    backdrop-filter: blur(3px);
  }
`
Nav.Title = styled.li`
  height: 29px;
  width:  ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : widthWithPadding};
  font-weight: lighter;
  padding-top: 0px;
  padding-bottom: 10px;
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : ''};
  span {
    display: ${props => props.resize && !props.resizeOpen ? 'none' : 'block'};
    align-self: center;
  }
  i {
    display: ${props => props.resize && !props.resizeOpen ? 'block' : 'none'};
    align-self: center;
  }

  @media (max-width: 992px) {
    display: block;
    justify-content: flex-start;
    width: ${widthWithPadding};

    span {
      display: block;
    }
    i {
      display: none;
    }
  }
`
Nav.Swipe = styled.div`
  display: none;
  position: fixed;
  width: 30px;
  height: 100%;
  z-index: 1;
  
  @media (max-width: 992px) {
    display: block;
  }
`

/* Start Brand */
Nav.Brand = styled.div`
  color: ${primary};
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: ${heightHeader};
  display: flex;
  justify-content: space-between;
  background: transparent;
  padding: 0 ${props => props.resize && !props.resizeOpen ? '4' : '10'}px;
  transition: .3s ease;
  border-bottom: 1px solid rgba(255,255,255,.07);

  z-index: 1;

  @media (max-width: 992px) {
    padding: 0 20px;
    justify-content: center;
    width: ${widthFull};
  }
`
Nav.Brand.Link = styled.a`
  align-self: center;
`
Nav.Brand.Logo = styled.img`
  width: ${props => props.resize && !props.resizeOpen ? '50px' : '140px'};
  align-self: center;
  transition: .5s;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    display: none;
  }
`
Nav.Brand.IconSize = styled.div`
  align-self: center;
  padding: 5px;
  cursor: pointer;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'flex'};
  justify-content: center;
  font-size: 1.2rem;
  color: #fff;

  @media (max-width: 992px) {
    display: none;
  }
`
Nav.Brand.IconMobile = styled.div`
  align-self: center;
  display: none;
  padding: 5px;
  font-size: 1.2rem;

  @media (max-width: 992px) {
    display: flex;
  }
`
/* End Brand */

/* Start One Level */
Nav.OneLevel = styled.ul`
  padding: 0 14px 28px;
  padding-top: 128px;
  list-style: none;
`
Nav.OneLevel.Item = styled.li`
  padding-bottom: 6px;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : widthWithPadding};

  @media (max-width: 992px) {
    width: ${widthWithPadding};
  }
`
Nav.OneLevel.TitleContent = styled.div`
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : 'space-between'};;
  color: ${props => props.active ? '#ffffff' : '#9caa9f'};
  background: ${props => props.active ? 'rgba(91,175,28,.16)' : 'transparent'};
  border: 1px solid ${props => props.active ? 'rgba(132,204,22,.22)' : 'transparent'};
  border-radius: 10px;
  padding: 10px 11px;
  cursor: pointer;
  margin-bottom: 5px;
  height: 39px;

  &:hover {
    color: #fff;
    background: rgba(255,255,255,.055);
  }

  @media (max-width: 992px) {
    justify-content: space-between;

  }
`
Nav.OneLevel.Title = styled.div`
  align-self: center;
  transition: .5s;
  display: flex;
`
Nav.OneLevel.IconArrow = styled.span`
  align-self: center;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  transform: ${props => props.active ? 'rotate(225deg)' : 'rotate(135deg)'};
  transition: .5s;
  content: '';
  width: 4px;
  height: 4px;
  border-width: 1px 0 0 1px;
  border-style: solid;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
Nav.OneLevel.Icon = styled.span`
  margin-right: ${props => props.resize && !props.resizeOpen ? '' : '1rem'};
  display: flex;
  width: 20px;
  align-self: center;

  @media (max-width: 992px) {
    margin-right: 1rem;
  }
`
Nav.OneLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  align-self: center;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
/* End One Level */

/* Start Second Level */
Nav.SecondLevel = styled.ul`
  list-style: none;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : (props.active ? 'block' : 'none')};
  @media (max-width: 992px) {
    display: ${props => props.active ? 'block' : 'none'};
  }
`
Nav.SecondLevel.Item = styled.li`
  display: flex;
  justify-content: space-between;
  background: ${props => props.active ? 'rgba(91,175,28,.92)' : ''};
  color: ${props => props.active ? '#fff' : ''};
  box-shadow: ${props => props.active ? `0 6px 20px 0 ${bgPrimaryLight}` : ''};
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;

  & span:last-child {
    color: ${props => props.active ? '#fff' : '#94a3b8'};
  }

  &:hover {
    background: rgba(255,255,255,.05);
  }

  &:hover div {
    padding-left: 4px;
  }
`
Nav.SecondLevel.Title = styled.div`
  align-self: center;
  transition: .325s;
  display: flex;
  height: 20px;
`
Nav.SecondLevel.Icon = styled.span`
  margin-right: 1rem;
  align-self: center;
  display: flex;
  width: 8px;
  height: 8px;
  border-radius: 10px;
  border: 1px solid #64748b;
`
Nav.SecondLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  font-weight: 500;
  color: #94a3b8;
  width: ${widthWithPadding};
  align-self: center;

  @media (max-width: 992px) {
    display: inline-block !important;
  }
`
/* End Second Level */

export default Nav
